import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { getPostCover } from '@wix/communities-blog-client-common';

import { connect } from '../../../common/components/runtime-context';
import RecentPostsListItemWithCover from './recent-posts-list-item-with-cover';
import RecentPostsListItemWithoutCover from './recent-posts-list-item-without-cover';
import withFontClassName from '../../../common/hoc/with-font-class-name';
import styles from './recent-posts-list-item.scss';
import withMediaHosts from '../../../common/hoc/with-media-hosts';

export const RecentPostsListItem = (props) => {
  const { post, incrementPostLikeCount, isMetadataFooterVisible, imageHost, videoHost } = props;
  const onLikeClick = () => incrementPostLikeCount(post._id);
  const { shouldRender: withCover, imageMetadata, videoMetadata } = getPostCover(post, imageHost, videoHost);
  const postLink = `/${post.slug}`;
  const Component = withCover ? RecentPostsListItemWithCover : RecentPostsListItemWithoutCover;
  const componentProps = {
    postLink,
    type: 'recentPosts',
    onLikeClick,
    imageMetadata,
    videoMetadata,
    ...props,
  };

  const articleStyle = { paddingTop: `calc(56.25% + ${isMetadataFooterVisible ? '148px' : '103px'})` };

  return (
    <article className={styles.article} tabIndex="0" data-hook="recent-post-list-item" style={articleStyle}>
      <div className={styles.container}>
        <Component {...componentProps} />
      </div>
    </article>
  );
};

RecentPostsListItem.propTypes = {
  post: PropTypes.object.isRequired,
  incrementPostLikeCount: PropTypes.func.isRequired,
  isMetadataFooterVisible: PropTypes.bool.isRequired,
  imageHost: PropTypes.string.isRequired,
  videoHost: PropTypes.string.isRequired,
};

const mapRuntimeToProps = (state, ownProps, actions) => ({
  incrementPostLikeCount: actions.incrementPostLikeCount,
});

// prettier-ignore
export default flowRight(
  withFontClassName,
  withMediaHosts,
  connect(mapRuntimeToProps),
)(RecentPostsListItem);
